import React, { FunctionComponent } from 'react';

import cls from 'classnames';

import { isNetquestClient, isPureProfileClient } from '../../../../utils/clients';
import netquestLogo from '../../../../assets/netquest/Flash-Survey-Logo-White.svg';
import pureprofileLogo from '../../../../assets/pureprofile/logo-for-light-bg.png';
import sightXLogo from '../../../../assets/sightXWithRepdataLogo.svg';

import styles from './logo.module.scss';

export const Logo: FunctionComponent = () => {
  const isNetquest = isNetquestClient();
  const isPureProfile = isPureProfileClient();
  if (isNetquest) {
    return <>
      <div className={cls(styles.container, styles.netquest)}>
        <img className={styles.logo} src={netquestLogo} alt="Netquest Logo" />
        <div className={styles.powerBySightX}>
          <span className={styles.label}>Powered by</span>
          <img className={styles.miniLogo} src={sightXLogo} alt="SightX Logo" />
        </div>
      </div>
    </>;
  }
  if(isPureProfile) {
    return (
      <div className={cls(styles.container, styles.pureprofile)}>
        <img className={styles.logo} src={pureprofileLogo} alt="Pureprofile Logo" />
        <div className={styles.powerBySightX}>
          <span className={styles.label}>Powered by</span>
          <img className={styles.miniLogo} src={sightXLogo} alt="SightX Logo" />
        </div>
      </div>
    );
  }
  return <div className={cls(styles.container, styles.sightx)}>
    <img className={styles.logo} src={sightXLogo} alt="SightX Logo" />
  </div>;
};
